import { buildPsdFontResolver } from "@hightouch/lib/ad-studio/psd-export/psd-font";
import { buildIdmlBlob } from "src/pages/ad-studio/idml-export/build-idml";
import { buildPsdBlob } from "src/pages/ad-studio/psd-export/build-psd";
import { emailLayerArtifactSchema } from "@hightouch/lib/ad-studio/psd-export/email-layer-artifact";

export type LayeredFormat = "psd" | "idml";

export async function buildEmailLayeredBlob(
  input: unknown,
  format: LayeredFormat,
): Promise<Blob> {
  const args = emailLayerArtifactSchema.parse(input);
  const resolveFont = buildPsdFontResolver(args.fontFiles);
  const build = format === "psd" ? buildPsdBlob : buildIdmlBlob;
  return build({
    content: args.content,
    fontRules: args.fontRules,
    componentAssets: null,
    apiBase: "",
    resolveFont,
  });
}
